import './IconButton.css';

import type { FunctionComponent } from 'react';

import type { Icon, IconProps } from '../Icons/types';

interface IconButtonProps extends IconProps {
  onClick: () => void;
  Icon: Icon;
}

export const IconButton: FunctionComponent<IconButtonProps> = ({
  onClick,
  Icon,
  ...props
}) => (
  <div onClick={onClick} className="icon-button">
    <Icon {...props} />
  </div>
);
